<div class="contains-button">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <!-- Hiển thị khối hộp thoại -->
      <mat-form-field style="width: 100%">
        <mat-label>{{'chon_khoi_hien_thi' | translate}}</mat-label>
        <mat-select placeholder="{{'chon_khoi_hien_thi' | translate}}" style="width:100%" [(ngModel)]="staticdata['id_freeblock']"
          (ngModelChange)="updateStaticData(); vhEventMediator.notifyOnConfigChanged({ _id: this.objectChoosing._id, change_block: true })">
          <mat-option *ngFor="let block of listBlockPopupDetail" [value]="block._id">{{block.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>



  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
      <!-- Hiển thị khối hộp thoại -->
      <mat-form-field  style="margin-top: 10px; width: 100%">
        <mat-label>{{'chon_khoi_hien_thi' | translate}}</mat-label>
        <mat-select placeholder="{{'chon_khoi_hien_thi' | translate}}" style="width:100%" [(ngModel)]="staticdata['id_freeblock']"
          (ngModelChange)="updateStaticData(); vhEventMediator.notifyOnConfigChanged({ _id: this.objectChoosing._id, change_block: true })">
          <mat-option *ngFor="let block of listBlockPopupDetail" [value]="block._id">{{block.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <ul nz-menu nzMode="inline">
        <!-- Cấu hình thông số cơ bản của button-->
        <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
          <div class="button-size">
            <!-- Lựa chọn hiển thị cho các thiết bị -->
            <app-hide-show-config
                      [device]="device"
                      [elementChoosing]="objectChoosing">
            </app-hide-show-config>
          </div>
        </li>
        <!-- Cấu hình tái sử dụng thiết kế-->
    
        <!-- Cấu hình format font name của button -->
        <li nz-submenu nzTitle="{{'dinh_dang_ten_nut' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
          <div class="container-font">
            <div class="config-text" style="width: 100%">
              <!-- Nhập nội dung của nút -->
              <mat-form-field style="width: 100%">
                <mat-label> {{'noi_dung' | translate}}</mat-label>
                <textarea matInput
                  [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                  (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
                  (blur)="updateContent('content');"></textarea>
              </mat-form-field>
              <!-- Nếu nội dung không có thì phải có nhãn -->
              <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate"
              *ngIf="!staticdata['content_' + functionService.selectedLanguageCode]?.trim()">
                <mat-label>{{'nhan_cua_nut' | translate}}<span style="color: red">*</span></mat-label>
                <textarea matInput
                  [ngModel]="staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode]"
                  (ngModelChange)="staticdata.accessibility['aria_label_' + functionService.selectedLanguageCode] = $event"
                  (blur)="updateContent('aria_label', true);"></textarea>
              </mat-form-field>
            </div>
            <app-text-format-config
            [device]="device"
            [objectChoosing]="objectChoosing"
            [class]="class"
            [config]="config"
            [staticdata]="staticdata"
            [textContentClass]="class['popup-detail__content']"
            [textWrapperClass]="class['popup-detail']"
          >
          </app-text-format-config>
            <div class="font-adjusting">
              <div class="row-spacing">
                <span class="title">{{'gian_cach_chu' | translate}}</span>
                <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                      class['popup-detail__content']['letter-spacing'] | vhnumber
                    " (nzBlur)="updateClass()" (ngModelChange)="
                      class['popup-detail__content']['letter-spacing'] =
                        $event + 'px'
                    "></nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="
                        class['popup-detail__content']['letter-spacing'] | vhnumber
                      " (nzOnAfterChange)="updateClass()" (ngModelChange)="
                        class['popup-detail__content']['letter-spacing'] =
                          $event + 'px'
                      "></nz-slider>
            </div>
            <div class="font-adjusting">
              <div class="row-spacing">
                <span class="title">{{'khoang_cach_dong' | translate}}</span>
                <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
                  [(ngModel)]="class['popup-detail__content']['line-height']" (nzBlur)="updateClass()"></nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="3" [nzStep]="0.1"
                [(ngModel)]="class['popup-detail__content']['line-height']" (nzOnAfterChange)="updateClass()"></nz-slider>
            </div>
    
            <label class="px-1">{{'gian_cach' | translate}}</label>
            <div class="padding">
              <div class="d-flex items">
                <img src="/assets/root/images/system/icons/padding-top.svg" alt="1"
                  width="30px">
                <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%;" [nzStep]="1"
                  [ngModel]="class['popup-detail']['padding-top']| vhnumber" (nzBlur)="updateClassAndWidthHeight()"
                  (ngModelChange)="class['popup-detail']['padding-top'] = $event + 'px'; class['popup-detail']['padding-bottom'] = $event + 'px'"></nz-input-number>
              </div>
              <div class="d-flex items">
                <img src="/assets/root/images/system/icons/padding-right-left.svg" alt="1"
                  width="30px">
                <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%;" [nzStep]="1"
                  [ngModel]="class['popup-detail']['padding-left'] | vhnumber " (nzBlur)="updateClassAndWidthHeight()"
                  (ngModelChange)="class['popup-detail']['padding-right'] = $event + 'px'; class['popup-detail']['padding-left'] = $event + 'px'"></nz-input-number>
              </div>
            </div>
          </div>
        </li>
        <!-- Cấu hình màu nền của button -->
        <li nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
          <div class="container-color">
            <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
              [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event)" nz-tooltip
              [disabled]="config['background-color'].gradient_check"></button>
          </div>
          <div class="color-pick">
            <span class="title w-50">{{'chon_mau' | translate}}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class['popup-detail']['background-color']"
              [style.background]="class['popup-detail']['background-color']" (colorPickerClose)="updateObject()"
              [cpWidth]="'230px'" />
          </div>
          <div class="mr-2 mb-4 mt-4 view-more"
            style="display: flex; align-items: center;justify-content: flex-end; gap: 7px">
            <p class="discover_text" (click)="openViewAll(styles_field[3])"
              style="cursor: pointer; text-align: left; margin: 0">
              {{'mo_rong' | translate}} &#8594;
            </p>
          </div>
          <!-- Mở popup so sánh màu tương phản -->
          <button *ngIf="staticdata['content_' + functionService.selectedLanguageCode]"
          nz-row (click)="openColorContrast()" nz-tooltip
          [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
          style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;">
            {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
          </button>
        </li>
        <!-- Cấu hình biểu tượng -->
        <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
          <app-symbol-config
                [device]="device"
                [class]="class"
                [config]="config"
                [symbolClass]="class['popup-detail']"
                [fontSizeIconClass]="class['popup-detail__content--icon-wrapper']"
                [symbolConfig]="config['flex-direction']"
                [objectChoosing]="objectChoosing">
          </app-symbol-config>
        </li>
        <!-- Cấu hình hình dạng viền -->
        <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
          <app-borders-config [device]="device"
                              [class]="class"
                              [borderClass]="class['popup-detail']"
                              [id_object]="objectChoosing._id"
          >
          </app-borders-config>
    
          <!-- Nút mở rộng -->
          <div class="item-border my-3" style="float: right;">
            <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </li>
        <!-- Cấu hình đổ bóng -->
        <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
          <app-shadow-config
                [device]="device"
                [config]="config"
                [class]="class"
                [shadowClass]="class['popup-detail']"
                [shadowConfig]="config['box-shadow']"
                [objectChoosing]="objectChoosing"
                >
          </app-shadow-config>
        </li>
        <!-- Cấu hình hiệu ứng -->
        <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
          <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
            [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
            [cursorClass]="class['popup-detail']" [effect_hover]="effect_hover" [customize]="customize" [effectFileUsing]="'button'">
          </app-choose-animations-config>
        </li>
    
      </ul>
  </ng-container>
  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['popup-detail']"
                    [id_object]="objectChoosing._id"
      >
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
      <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
        [device]="device"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 4">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check"
          (ngModelChange)="updateBackgroundRgb()"></label>
      </div>
      <div class="list-gradient">
        <button class="btn-gradient" *ngFor="
              let bgGradient of config['background-color']['gradient_arr'];
              let i = index
            " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
          [disabled]="!config['background-color'].gradient_check">
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{ 'them_mau' | translate }}</p>
      <div class="container_add-gradient">
        <input class="input-color" [cpOKButton]="true" [(colorPicker)]="class['popup-detail']['background-color']" type="button"
          [disabled]="!config['background-color'].gradient_check"
          [style.background]="class['popup-detail']['background-color']" (colorPickerClose)="addGradient($event)" />
      </div>
      <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
      <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip [nzTooltipTitle]="type.name"
        (click)="chooseOption(type, $event)" [disabled]="!config['background-color'].gradient_check" [style.background]="
            'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'"></button>
    </div>
  </div>
</div>
